import { Box, Chip as MuiChip, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import Filter3LineIcon from 'remixicon-react/Filter3LineIcon';
import MoreFiltersModal from './MoreFiltersModal';
import { FeedFilter } from 'api/KnowledgeAPI';
import CloseCircleFillIcon from 'remixicon-react/CloseCircleFillIcon';
import { theme } from 'config/theme';

type AllPostsFiltersProps = {
  selectedFilters: FeedFilter[];
  clearFilters: () => void;
  filters: Record<string, FeedFilter[]>;
  setFilters: (
    companyId: string,
    filters: FeedFilter[],
    tab: string,
    userFiltersSynced?: boolean,
  ) => void;
};

function AllPostsFilters({
  selectedFilters,
  clearFilters,
  filters,
  setFilters,
}: AllPostsFiltersProps) {
  const [openFiltersModal, setOpenFiltersModal] = useState(false);

  return (
    <Container>
      <Chip
        label={
          <Box display="flex" alignItems="center">
            <Filter3LineIcon size={20} />
            &nbsp;Filters
            {selectedFilters.length > 0 && (
              <>
                &nbsp;({selectedFilters.length})
                <IconButton
                  size="small"
                  sx={(theme) => ({
                    ml: 0.5,
                    color: theme.palette.custom.pinkSwan,
                    '&:hover': { color: 'inherit' },
                  })}
                  onClick={(event) => {
                    event.stopPropagation();
                    clearFilters();
                  }}
                  title="Clear Filters"
                >
                  <CloseCircleFillIcon size={20} color={theme.palette.custom.pirateGold} />
                </IconButton>
              </>
            )}
          </Box>
        }
        variant="outlined"
        size="small"
        onClick={() => setOpenFiltersModal(true)}
        {...(selectedFilters.length > 0 && {
          sx: (theme) => ({
            backgroundColor: theme.palette.custom.earlyDawn,
            borderColor: theme.palette.custom.paleGold,
            color: theme.palette.custom.brown,
            '&:hover': {
              backgroundColor: `${theme.palette.custom.earlyDawn} !important`,
            },
          }),
        })}
      />
      {openFiltersModal && (
        <MoreFiltersModal
          open={openFiltersModal}
          setOpen={setOpenFiltersModal}
          filters={filters}
          setFilters={setFilters}
        />
      )}
    </Container>
  );
}

const Chip = styled(MuiChip, { label: 'Chip' })(({ theme }) => ({
  cursor: 'pointer',
  padding: '16px 8px',
  textTransform: 'capitalize',
  backgroundColor: theme.palette.custom.white,
}));

const Container = styled(Box, { label: 'Container' })({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export default AllPostsFilters;
